__turbopack_context__.v({
  "bentoImage": "ea9zMa_bentoImage",
  "carouselWrap": "ea9zMa_carouselWrap",
  "heading": "ea9zMa_heading",
  "heightFitImage": "ea9zMa_heightFitImage",
  "naturalFitImage": "ea9zMa_naturalFitImage",
  "section": "ea9zMa_section",
});
